var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "product-by-sheet" } }, [
    _c("h4", { staticClass: "mb-3 text-center" }, [
      _vm._v("Choose a Standard size, or enter your own dimensions"),
    ]),
    _c(
      "div",
      { staticClass: "text-center mb-3" },
      [
        _c(_setup.BFormRadioGroup, {
          attrs: {
            options: _setup.sizeTypeOptions,
            buttons: "",
            "button-variant": "brand",
            size: "lg",
          },
          on: { change: _setup.onSizeTypeChange },
          model: {
            value: _setup.sizeType,
            callback: function ($$v) {
              _setup.sizeType = $$v
            },
            expression: "sizeType",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _setup.sizeType == "bespoke",
            expression: 'sizeType == "bespoke"',
          },
        ],
        attrs: { id: "bespoke-size-inputs" },
      },
      [
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(_setup.UnitSelector, {
              staticClass: "mb-3",
              model: {
                value: _setup.displayUnit,
                callback: function ($$v) {
                  _setup.displayUnit = $$v
                },
                expression: "displayUnit",
              },
            }),
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "div",
                { staticClass: "col-md-9" },
                [
                  _c(_setup.SizeInput, {
                    attrs: {
                      unit: _setup.displayUnit,
                      size: "lg",
                      valid: _setup.areDimensionsValid,
                    },
                    model: {
                      value: _setup.size,
                      callback: function ($$v) {
                        _setup.size = $$v
                      },
                      expression: "size",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _setup.sizeType == "standard",
            expression: 'sizeType == "standard"',
          },
        ],
        attrs: { id: "standard-size-inputs" },
      },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-8" },
            [
              _c(_setup.StandardSizeSelector, {
                on: { input: _setup.onStandardSizeChanged },
                model: {
                  value: _setup.size,
                  callback: function ($$v) {
                    _setup.size = $$v
                  },
                  expression: "size",
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
    _c("hr"),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-md-6 order-2 order-md-1" }, [
        _c(
          "div",
          { staticClass: "card" },
          [
            _vm._m(0),
            _c(_setup.DiscountsBreakdown, {
              attrs: {
                "item-type": "Piece",
                "model-product-id": _setup.product.id,
                price: _setup.pricing.ex_vat_base_unit_price,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "col order-1 order-md-2" },
        [
          _c(
            _setup.BFormGroup,
            { attrs: { label: "Quantity:", "label-size": "lg" } },
            [
              _c(_setup.BFormInput, {
                attrs: {
                  type: "number",
                  number: "",
                  step: "1",
                  size: "lg",
                  min: "1",
                },
                model: {
                  value: _setup.quantity,
                  callback: function ($$v) {
                    _setup.quantity = $$v
                  },
                  expression: "quantity",
                },
              }),
            ],
            1
          ),
          _c(
            _setup.BOverlay,
            { attrs: { show: _setup.loadingPrice || _setup.loadingStock } },
            [
              _c("p", { staticClass: "mb-1" }, [
                _c("strong", [_vm._v("Size:")]),
                _vm._v(
                  " " +
                    _vm._s(_setup.size.width) +
                    "x" +
                    _vm._s(_setup.size.length) +
                    "mm"
                ),
              ]),
              _c("p", [
                _c("strong", [_vm._v("Quantity:")]),
                _vm._v(
                  " " +
                    _vm._s(_setup.quantity) +
                    " at £" +
                    _vm._s(_setup.pricing.unit_price)
                ),
              ]),
              _c(
                _setup.BAlert,
                {
                  attrs: {
                    variant: "warning",
                    show: _setup.validation.warnings.length > 0,
                  },
                },
                [
                  _vm._v("Warning:"),
                  _c(
                    "ul",
                    _vm._l(_setup.validation.warnings, function (warning, idx) {
                      return _c("li", { key: idx }, [_vm._v(_vm._s(warning))])
                    }),
                    0
                  ),
                ]
              ),
              _c(
                _setup.BAlert,
                {
                  attrs: {
                    variant: "danger",
                    show: !_setup.validation.isValid || !_setup.isInStock,
                  },
                },
                [
                  _vm._v("The following issues have been found:"),
                  _c(
                    "ul",
                    { staticClass: "mb-0" },
                    [
                      _vm._l(
                        _setup.validation.problems,
                        function (problem, idx) {
                          return _c("li", { key: idx }, [
                            _vm._v(_vm._s(problem)),
                          ])
                        }
                      ),
                      !_setup.isInStock
                        ? _c("li", [
                            _vm._v(
                              "There is not enough of this item in stock to fulfill your order."
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                _setup.BAlert,
                {
                  attrs: { show: !_setup.delivery.isValid, variant: "warning" },
                },
                [
                  _vm._v(
                    "This item is available for collection only from our showroom."
                  ),
                ]
              ),
              !(_setup.product && _setup.product.discontinued_at) ||
              _setup.isAdmin
                ? _c(
                    _setup.BButton,
                    {
                      staticClass: "mb-3",
                      attrs: {
                        variant: _setup.buyButtonVariant,
                        disabled: _setup.isAddToCartDisabled,
                        size: "lg",
                        block: "",
                      },
                      on: { click: _setup.addToCartHandler },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("shopping_cart"),
                      ]),
                      _vm._v(
                        "Add to Cart (£" +
                          _vm._s(_setup.pricing.total_price) +
                          " " +
                          _vm._s(_setup.vatMode) +
                          " VAT)"
                      ),
                    ]
                  )
                : _vm._e(),
              _setup.product && _setup.product.discontinued_at
                ? _c(_setup.ProductDiscontinued, {
                    attrs: { replacement: _setup.product.replacement },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _setup.product && _setup.product.upsell && _setup.product.upsell.length > 0
      ? _c("div", { staticClass: "mt-4", attrs: { id: "upsell" } }, [
          _c("h4", { staticClass: "mb-3" }, [_vm._v("Upgrade to:")]),
          _c(
            "div",
            { staticClass: "row grid" },
            _vm._l(
              _setup.product.upsell_products,
              function (upsell_product, key) {
                return _c(_setup.UpsellSheetProduct, {
                  key: `upsell-${key}`,
                  attrs: {
                    product: upsell_product,
                    size: _setup.size,
                    "base-price": _setup.pricing.unit_price,
                    quantity: _setup.quantity || 1,
                  },
                })
              }
            ),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title" }, [_vm._v("Volume Discounts")]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("The more you buy, the more you save!"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }